
import { defineComponent } from 'vue';
import FeatureCard from './generic/FeatureCard.vue';

export default defineComponent({
  name: 'DiscoverComponent',
  components: { FeatureCard },
  setup() {
    const cards = [
      {
        imgAlt: 'some image',
        link: '/minesweeper',
        header: 'Minesweeper',
        body: 'Classical minesweeper game at its best! Ready to solve with 3 different levels, hints and autosolve option for quitters!',
      },
      {
        imgAlt: 'some image',
        link: '/chatbot',
        header: 'Annoying ChatBot',
        body: 'A really annoying, limited and dumb chatbot. It works through a free REST API, the blame is not mine.',
      },
      {
        imgAlt: 'some image',
        link: '#',
        header: 'Word Search Puzzle - Coming',
        body: 'Anoter classic! Auto generated, printable and online solvable word search puzzles! Coming soon!',
        disabled: true,
      },
    ];
    return {
      cards,
    };
  },
});
